var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-sm table-hover table-striped" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.localOrders, function (order) {
          return _c("tr", { key: order.id }, [
            _c(
              "td",
              [
                _vm._v("\n        " + _vm._s(order.id) + "\n        "),
                _c("p", [
                  _c("strong", [_vm._v(_vm._s(order.project_label))]),
                  _vm._v(
                    " (" +
                      _vm._s(_vm.$AllCities[order.city_id].short_name) +
                      ")"
                  ),
                ]),
                _vm._v(" "),
                _vm.showStoreData && order.is_agreed
                  ? [
                      _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("Согласовано"),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                (order.comment && order.comment.length) || order.reject_comment
                  ? [
                      _c("i", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: _vm.getComments(order),
                              placement: "bottom-center",
                              classes: ["info custom-tooltip"],
                              targetClasses: [
                                "it-has-a-tooltip custom-tooltip",
                              ],
                              offset: 10,
                              delay: {
                                show: 200,
                                hide: 700,
                              },
                            },
                            expression:
                              "{\n                  content: getComments(order),\n                  placement: 'bottom-center',\n                  classes: ['info custom-tooltip'],\n                  targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                  offset: 10,\n                  delay: {\n                    show: 200,\n                    hide: 700\n                  }\n                }",
                          },
                        ],
                        staticClass:
                          "icon-fa icon-fa-info-circle comment_tooltip_fa",
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      order.client_name || (order.client && order.client.name)
                    )
                  ),
                ]),
                _vm._v(" "),
                _vm._l(order.order_phones, function (phone) {
                  return _c("p", [
                    _vm._v(_vm._s(_vm.mixinPrintPhone(phone.phone.phone))),
                  ])
                }),
                _vm._v(" "),
                !order.extra_options.callDeal
                  ? _c("AgreementButton", { attrs: { order: order } })
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$AllCities[order.city_id].name)),
                ]),
              ]),
              _vm._v("\n        " + _vm._s(order.address) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "td",
              { class: _vm.getOrderClass(order.id) },
              _vm._l(order.details, function (detail) {
                return _c(
                  "div",
                  { staticClass: "drug_details" },
                  [
                    _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(detail.drug.prep) +
                          " (" +
                          _vm._s(detail.drug_id) +
                          ")\n            "
                      ),
                      detail.drug.cool
                        ? _c("span", { staticClass: "cool_mark" }, [
                            _c("i", { staticClass: "icon icon-snowflake" }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.drug.pack_comment
                        ? _c("i", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: detail.drug.pack_comment,
                                  placement: "bottom-center",
                                  classes: ["info"],
                                  targetClasses: ["it-has-a-tooltip"],
                                  offset: 20,
                                  delay: {
                                    show: 500,
                                    hide: 300,
                                  },
                                },
                                expression:
                                  "{\n                      content: detail.drug.pack_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                              },
                            ],
                            staticClass: "icon-fa icon-fa-info-circle",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      detail.drug.pack_box_comment
                        ? _c("i", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: detail.drug.pack_box_comment,
                                  placement: "bottom-center",
                                  classes: ["info"],
                                  targetClasses: ["it-has-a-tooltip"],
                                  offset: 20,
                                  delay: {
                                    show: 500,
                                    hide: 300,
                                  },
                                },
                                expression:
                                  "{\n                      content: detail.drug.pack_box_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                              },
                            ],
                            staticClass: "icon-fa icon-fa-info-circle",
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    detail.pack_set !== 1
                      ? [
                          _c("p", [
                            _c("strong", [
                              _vm._v("x " + _vm._s(detail.pack_set)),
                            ]),
                            _vm._v(" (компл)"),
                            _c("strong", [
                              _vm._v(
                                " * " + _vm._s(detail.price * detail.pack_set)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("x " + _vm._s(detail.qty))]),
                            _vm._v(" завод. упак."),
                            _c("strong", [
                              _vm._v(" * " + _vm._s(detail.price)),
                            ]),
                          ]),
                        ]
                      : [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                "x " +
                                  _vm._s(detail.qty) +
                                  " * " +
                                  _vm._s(detail.price)
                              ),
                            ]),
                          ]),
                        ],
                    _vm._v(" "),
                    _vm.showStoreData
                      ? [
                          _c("StoreData", {
                            attrs: {
                              storeInfo: {
                                actualStoreData:
                                  _vm.storeData.actualStoreData &&
                                  _vm.storeData.actualStoreData[detail.drug_id],
                                inStores:
                                  _vm.storeData.inStores[detail.drug_id],
                                requests:
                                  _vm.storeData.requests[detail.drug_id],
                                transitDetails:
                                  _vm.storeData.transitDetails[detail.drug_id],
                              },
                              order: order,
                              drug: detail.drug,
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "flex" }, [
                _c("div", [_vm._v(_vm._s(order.price))]),
                _vm._v(" "),
                _vm.sendMessageModal[order.id] &&
                _vm.sendMessageModal[order.id].supervisor
                  ? _c(
                      "div",
                      { staticClass: "ml-2" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.sendTelegramMessage(
                                  order.id,
                                  "supervisorModal"
                                )
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "icon-fa icon-fa-user-secret chat_icon",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.sendMessageModal[order.id].supervisorModal
                          ? _c("SendRunnerMessage", {
                              attrs: {
                                data: order,
                                type: "supervisor",
                                onModalClose: () =>
                                  (_vm.sendMessageModal[
                                    order.id
                                  ].supervisorModal = false),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                order.courier
                  ? [_c("p", [_vm._v(_vm._s(order.courier.name))])]
                  : _vm._e(),
                _vm._v(" "),
                _vm.sendMessageModal[order.id] &&
                _vm.sendMessageModal[order.id].runner
                  ? _c(
                      "div",
                      {},
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.sendTelegramMessage(
                                  order.id,
                                  "runnerModal"
                                )
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "icon-fa icon-fa-motorcycle chat_icon",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.sendMessageModal[order.id].runnerModal
                          ? _c("SendRunnerMessage", {
                              attrs: {
                                data: order,
                                type: "runner",
                                onModalClose: () =>
                                  (_vm.sendMessageModal[
                                    order.id
                                  ].runnerModal = false),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.printCreateDate(order)) +
                    "\n        "
                ),
                _vm.showStoreData
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-xs btn-info pull-left mr-2",
                          on: {
                            click: function ($event) {
                              return _vm.orderToEdit(order.id)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("td", { attrs: { width: "80px" } }, [_vm._v("Номер")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "200px" } }, [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "300px" } }, [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("td", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "80px" } }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "170px" } }, [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "100px" } }, [_vm._v("Дата доставки")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }